import apiClient from "./client";
import type { BranchesListResponse, GetBranchesParams } from "../types/site";

export const getBranches = async (
  params: GetBranchesParams
): Promise<BranchesListResponse> => {
  const { data } = await apiClient.get<BranchesListResponse>("/branches", {
    params: {
      disaster_id: params.disaster_id,
      pref_code: params.pref_code,
      m_customer_id: params.m_customer_id,
      order: params.order,
      sort: params.sort,
      page: params.page,
    },
  });
  return data;
};
